/**
 * Power BI Embed Service
 */
import apiClient from './apiClient';
import { models } from 'powerbi-client';

export const powerbiService = {
  /**
   * Get embed configuration for a Power BI report
   */
  async getEmbedConfig(reportId?: string): Promise<models.IReportEmbedConfiguration> {
    try {
      const response = await apiClient.post('/embed-token', {
        reportId,
      });

      return {
        type: 'report',
        id: response.data.reportId,
        embedUrl: response.data.embedUrl,
        accessToken: response.data.embedToken,
        tokenType: models.TokenType.Embed,
        settings: {
          panes: {
            filters: { visible: false, expanded: false },
            pageNavigation: { visible: true },
          },
          background: models.BackgroundType.Transparent,
          layoutType: models.LayoutType.Custom,
          customLayout: {
            displayOption: models.DisplayOption.FitToPage,
          },
        },
      };
    } catch (error: any) {
      console.error('Error getting embed token:', error);
      
      // Check for specific error types
      if (error.message && error.message.includes('consent_required')) {
        throw new Error(
          'Additional permissions required. Please log out and log back in to grant Power BI access.'
        );
      }
      
      throw new Error(
        error.response?.data?.error || error.message || 'Failed to get Power BI embed token'
      );
    }
  },
};
